import React, { useState, useEffect } from 'react';
import AssessmentIcon from '@mui/icons-material/Assessment';
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Chip,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  Fade,
  Grow,
  Zoom,
  alpha,
  Skeleton,
  Stack,
  Avatar,
  Fab,
} from '@mui/material';
import {
  Event as EventIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendingIcon,
  ArrowForward as ArrowForwardIcon,
  Newspaper as NewspaperIcon,
  PhotoCamera as PhotoCameraIcon,
  Mic as MicIcon,
  Groups as GroupsIcon,
  Celebration as CelebrationIcon,
  Public as PublicIcon,
  School as SchoolIcon,
  Share as ShareIcon,
  Launch as LaunchIcon,
  Star as StarIcon,
  Flight as FlightIcon,
  Language as LanguageIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { motion } from 'framer-motion';

function ActualitesEtEvenements() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  
  // Couleurs atténuées
  const primaryColor = '#D32F2F'; // Rouge plus doux
  const secondaryColor = '#2E7D32'; // Vert plus doux
  const tertiaryColor = '#f8f9fa';
  const white = '#ffffff';
  const accentColor = '#1976d2';
  const neutralGray = '#757575';

  const [imagesLoaded, setImagesLoaded] = useState({});
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Catégories d'événements
  const categories = [
    { id: 0, label: 'Tous', icon: <EventIcon /> },
    { id: 7, label: 'Activités sur terrain', icon: <LanguageIcon /> },
    { id: 1, label: 'Événements', icon: <CelebrationIcon /> },
    { id: 2, label: 'Conférences', icon: <MicIcon /> },
    { id: 3, label: 'Académique', icon: <SchoolIcon /> },
    { id: 4, label: 'Photos', icon: <PhotoCameraIcon /> },
    { id: 5, label: 'Formations / Ateliers', icon: <LanguageIcon /> },
    { id: 6, label: 'Résultats Internationaux', icon: <PublicIcon /> }
  ];

  // Fonction pour obtenir le chemin des images
  const getImagePath = (fileName) => {
    if (!fileName || fileName.trim() === '') return null;
    
    const cleanName = fileName.trim();
    const extensions = ['.jpg', '.jpeg', '.png', '.webp', '.JPG', '.JPEG', '.PNG'];
    const hasExtension = extensions.some(ext => cleanName.endsWith(ext));
    
    if (hasExtension) {
      return `/assets/formation/${cleanName}`;
    } else {
      return `/assets/formation/${cleanName}.jpg`;
    }
  };

  // Événements principauxmissionCommunicationPage
  const evenementsPrincipaux = [

  {
    id: 'formation-eicvmb-2026',
    title: 'Formation agents enquêteurs EICVMB 2025-2026',
    subtitle: 'Lancement de la collecte nationale',
    date: '04 Février 2026',
    description: 'Formation des agents pour l\'enquête sur les conditions de vie des ménages.',
    image: '/assets/formation/dg_consultante.jpeg',
    icon: <AssessmentIcon />,
    color: '#008D36',
    lien: '/formationEnqueteursPage',
    badge: 'Formation Enquêteurs',
    category: 5,
    featured: true,
    stats: { participants: 'Agents formés', duration: 'Collecte jusqu\'à février 2027' }
  },

  {
  id: 'mission-communication-ssn',
  title: 'Mission pour la stratégie de communication du SSN',
  subtitle: 'Stratégie de communication du Système Statistique National',
  date: '04 février 2026',
  description: 'Mission nationale visant à actualiser la stratégie de communication du SSN du Burundi afin d’améliorer la visibilité des statistiques.',
  image: '/assets/mission-communication/gitega.jpeg',
  icon: <AssessmentIcon />,
  color: '#008D36',
  lien: '/missionCommunicationPage',
  badge: 'Mission nationale',
  category: 7,
  featured: true,
  stats: { participants: '', duration: '1 semaine' }
}
,
     {
    id: 'resultats-odin-2024',
    title: 'Résultats ODIN 2024 pour le Burundi',
    subtitle: 'Évaluation de la couverture et de l\'ouverture des données',
    date: '29 Avril 2025',
    description: 'Publication des résultats de l\'Inventaire des Données Ouvertes (ODIN) 2024 par Open Data Watch.',
    image: getImagePath("odin-results.jpg"),
    icon: <AssessmentIcon />, 
    color: '#008D36', 
    lien: '/odinPage',
    badge: 'Résultats Internationaux',
    category: 6, 
    featured: true,
    stats: { participants: 'Open Data Watch', duration: '2 ans' }
  },
    {
      id: 'formation-inclusion',
      title: 'Formation sur l\'inclusion statistique',
      subtitle: 'Renforcement des capacités à Dakar & Yaoundé',
      date: '10-16 Décembre 2025',
      description: 'Formation sur l\'inclusion des populations déplacées de force dans les recensements et enquêtes nationales, suivie d\'un voyage d\'étude au Cameroun',
      image: getImagePath("photo_famille.png"),
      icon: <LanguageIcon />,
      color: '#2E7D32', 
      lien: '/formaFormationPage',
      badge: 'Formation Internationale',
      category: 5,
      featured: true,
      stats: { participants: 'Délégation INS Burundi', duration: '7 jours' }
    },
     {
      id: 'cloture-2025',
      title: 'Cérémonie de Clôture du MSB 2025',
      subtitle: '33ème Journée Africaine de la Statistique',
      date: '19 Novembre 2025',
      description: 'Clôture solennelle à l\'Hôtel Royal Palace avec présentation des résultats et discours du Premier Ministre',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace-photo_cloture.jpg',
      icon: <EventIcon />,
      color: '#2E7D32', // Vert doux
      lien: '/clotureMoisStatistique2025',
      badge: 'Clôture Solennelle',
      category: 1,
      featured: true,
      stats: { participants: '200+', duration: '1 journée' }
    },
    {
      id: 'cafe-statistique',
      title: 'Café Statistique - Couplage RGPH/RGAE',
      subtitle: 'Donatus Center Conference',
      date: '18 Novembre 2025',
      description: 'Un cadre d\'échange interactif pour capitaliser sur les expériences du RGPHAE 2024, explorer les innovations statistiques et renforcer les synergies entre les différents processus de collecte de données pour une meilleure planification du développement.',
      image: '/assets/msb/Cafe_Statistique_18-11-2025_DCC-photodefamille.jpg',
      icon: <GroupsIcon />,
      color: '#2E7D32', // Vert doux
      lien: '/cafeStatistiqueRGPH_RGAE',
      badge: 'Café Statistique',
      category: 1,
      featured: true,
        stats: { participants: '100+', duration:  '1 journée' }
    },
    {
      id: 'lancement-2025',
      title: 'Lancement du 14ème Mois de la Statistique',
      subtitle: '4ème Journée Mondiale de la Statistique',
      date: '20 Octobre 2025',
      description: 'Cérémonie officielle sous le Haut Patronage du Cabinet de la Primature avec point de presse animé par M. NDAYISENGA Modeste, DG ai de l\'INSBU',
      image: '/assets/msb/dgai_anime_presse_lancement_msb2025_celebration_jms2025.jpg',
      icon: <CelebrationIcon />,
     color: '#2E7D32', // Vert doux
      lien: '/lancementMoisStatistique2025',
      badge: 'Lancement Officiel',
      category: 1,
      featured: true,
      stats: { participants: '100+', duration: '1 journée' }
    },
    
    {
      id: 'congres-etudiants',
      title: '1er Congrès des Étudiants en Statistique',
      subtitle: 'Université du Lac Tanganyika',
      date: '06-07 Novembre 2025',
      description: 'Premier événement académique réunissant étudiants et professionnels pour échanger sur l\'avenir de la statistique au Burundi',
      image: '/assets/msb/CONGRES1.jpeg',
      icon: <GroupsIcon />,
      color: '#2E7D32', // Vert doux
      lien: '/premierCongresEtudiantsStatistique',
      badge: 'Première Édition',
      category: 3,
      featured: true,
      stats: { participants: '100+ étudiants', duration: '2 jours' }
    },
    
  ];

  // Articles récents
  const articlesRecents = [
    {
      id: 1,
      title: 'Café Statistique - Couplage RGPH/RGAE',
      date: '18 Novembre 2025',
      category: 'Conférence',
      excerpt: 'Retours d\'expérience du RGPHAE 2024 et perspectives d\'innovation statistique',
      lien: '/cafeStatistiqueRGPH_RGAE',
      icon: <PublicIcon />,
      color: accentColor,
      readingTime: '5 min',
      tags: ['RGPHAE', 'Innovation', 'Technologie']
    },
    {
      id: 2,
      title: 'Formation sur l\'inclusion statistique',
      date: '16 Décembre 2025',
      category: 'Formation',
      excerpt: 'Renforcement des capacités des instituts nationaux de statistique sur l\'inclusion des populations déplacées',
      lien: '/formation-inclusion',
      icon: <LanguageIcon />,
      color: '#2E7D32',
      readingTime: '4 min',
      tags: ['Formation', 'Dakar', 'Cameroun']
    }
  ];

  // Galerie d'images
  const galerieImages = [
    {
      id: 1,
      title: 'Photo de famille - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace-photo_cloture.jpg',
      event: 'Cérémonie de clôture',
      category: 4
    },
    {
      id: 2,
      title: 'Discours du Premier Ministre - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace-ministre.jpg',
      event: 'Discours de circonstance',
      category: 4
    },
    {
      id: 3,
      title: 'Intervention du DG de l\'INSBU - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace-dg.jpg',
      event: 'Allocution d\'accueil',
      category: 4
    },
    {
      id: 4,
      title: 'Formation à Dakar - Inclusion statistique',
      date: '12 Décembre 2025',
      image: getImagePath("photo-dg_ins_burundi_cammeroune.png"),
      event: 'Formation internationale',
      category: 5
    },
    {
      id: 5,
      title: 'Photo de famille à l\'INS Cameroun',
      date: '16 Décembre 2025',
      image: getImagePath("photo_famille.png"),
      event: 'Voyage d\'étude',
      category: 5
    },
    {
      id: 6,
      title: 'Allocution de l\'UNFPA - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace-representUNFPA.jpg',
      event: 'Partenaires au développement',
      category: 4
    },
    {
      id: 7,
      title: 'Présentation de Dr. NTAGAHORAHO Thierry - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/Cloture_JAS_19-11-2025_Royal_palace_thiery-18.jpg',
      event: 'Facilitateur de la cérémonie',
      category: 4
    },
    {
      id: 8,
      title: 'Participants - Clôture MSB 2025',
      date: '19 Novembre 2025',
      image: '/assets/msb/public4.jpg',
      event: 'Participants à la cérémonie',
      category: 4
    }
  ];

  const getFilteredEvents = () => {
    if (activeTab === 0) return [...evenementsPrincipaux, ...articlesRecents];
    return [...evenementsPrincipaux, ...articlesRecents].filter(event => 
      event.category === activeTab
    );
  };

  // Gestion du scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Composant Image Optimisé
  const OptimizedImage = ({ src, alt, height = 300, objectFit = 'contain', priority = false, borderRadius = 1 }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
      if (priority && src) {
        const img = new Image();
        img.src = src;
        img.onload = () => setIsLoading(false);
        img.onerror = () => {
          setIsLoading(false);
          setHasError(true);
        };
      }
    }, [src, priority]);

    if (hasError) {
      return (
        <Box sx={{ 
          height, 
          width: '100%', 
          bgcolor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: borderRadius
        }}>
          <PhotoCameraIcon sx={{ fontSize: 40, color: '#ddd' }} />
        </Box>
      );
    }

    return (
      <Box sx={{ position: 'relative', height, width: '100%' }}>
        {isLoading && (
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={height}
            animation="wave"
            sx={{ position: 'absolute', top: 0, left: 0, borderRadius: borderRadius }}
          />
        )}
        <Box
          component="img"
          src={src}
          alt={alt}
          onLoad={() => setIsLoading(false)}
          onError={() => {
            setIsLoading(false);
            setHasError(true);
          }}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: objectFit,
            opacity: isLoading ? 0 : 1,
            transition: 'opacity 0.5s ease',
            borderRadius: borderRadius,
            filter: isLoading ? 'blur(10px)' : 'blur(0)'
          }}
          loading={priority ? "eager" : "lazy"}
        />
      </Box>
    );
  };

  // Fonction pour naviguer
  const handleNavigation = (path) => {
    navigate(path);
  };

  // Fonction pour partager
  const handleShare = (title, url) => {
    if (navigator.share) {
      navigator.share({
        title: title,
        text: `Découvrez ${title} sur le site de l'INSBU`,
        url: window.location.origin + url,
      });
    } else {
      navigator.clipboard.writeText(window.location.origin + url);
      alert('Lien copié dans le presse-papier !');
    }
  };

  // Fonction pour remonter en haut
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box sx={{ 
      bgcolor: tertiaryColor, 
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        width: '50%',
        height: '50%',
        background: `radial-gradient(circle, ${alpha(primaryColor, 0.02)} 0%, transparent 50%)`,
        zIndex: 0
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '30%',
        height: '40%',
        background: `radial-gradient(circle, ${alpha(secondaryColor, 0.01)} 0%, transparent 50%)`,
        zIndex: 0
      }
    }}>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <NavigationBar />
        
        <Container maxWidth="lg" sx={{ py: 6 }}>
          {/* Hero Section avec animation */}
          <Fade in timeout={1000}>
            <Box sx={{ textAlign: 'center', mb: 8, pt: 2 }}>
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <Typography 
                  variant={isMobile ? "h6" : "h5"} 
                  component="h5" 
                  gutterBottom 
                  sx={{ 
                    fontWeight: 700,
                    color: secondaryColor,
                    mb: 2,
                    lineHeight: 1.2,
                  }}
                >
                  Actualités & Événements
                </Typography>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: 'text.secondary',
                    maxWidth: '800px',
                    mx: 'auto',
                    mb: 4,
                    lineHeight: 1.6,
                    fontSize: { xs: '1rem', md: '1rem' }
                  }}
                >
                  Suivez en temps réel les activités, innovations et réalisations 
                  du <strong>Système Statistique National</strong> du Burundi
                </Typography>
              </motion.div>
            </Box>
          </Fade>

          {/* Filtres par catégorie */}
          <Box sx={{ mb: 6 }}>
            <Stack 
              direction="row" 
              spacing={1} 
              sx={{ 
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: 1
              }}
            >
              {categories.map((category) => (
                <Chip
                  key={category.id}
                  icon={category.icon}
                  label={category.label}
                  onClick={() => setActiveTab(category.id)}
                  sx={{
                    bgcolor: activeTab === category.id ? alpha(primaryColor, 0.1) : 'white',
                    color: activeTab === category.id ? primaryColor : 'text.secondary',
                    border: `1px solid ${alpha(primaryColor, 0.1)}`,
                    '&:hover': {
                      bgcolor: alpha(primaryColor, 0.05),
                    }
                  }}
                />
              ))}
            </Stack>
          </Box>

          {/* Section Événements Principaux */}
          <Box sx={{ mb: 10 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              mb: 4,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: 0,
                width: '100px',
                height: '2px',
                bgcolor: neutralGray,
                borderRadius: 2
              }
            }}>
              <Typography variant="h6" sx={{ color: neutralGray, fontWeight: 400 }}>
                Événements Majeurs
                <StarIcon sx={{ ml: 1, fontSize: 28, color: alpha(secondaryColor, 0.7), verticalAlign: 'middle' }} />
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', bgcolor: alpha(neutralGray, 0.05), px: 2, py: 0.5, borderRadius: 1 }}>
                Cliquez pour découvrir
              </Typography>
            </Box>

            <Grid container spacing={2}>
              {getFilteredEvents()
                .filter(event => event.featured)
                .map((evenement, index) => (
                <Grid item xs={12} md={6} key={evenement.id}>
                  <Grow in timeout={500 + (index * 200)}>
                    <motion.div
                      whileHover={{ y: -8 }}
                      transition={{ type: "spring", stiffness: 300 }}
                    >
                      <Card 
                        sx={{ 
                          height: '100%',
                          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                          boxShadow: theme.shadows[1],
                          position: 'relative',
                          overflow: 'hidden',
                          borderRadius: 2,
                          border: `1px solid ${alpha(evenement.color, 0.08)}`,
                          '&:hover': {
                            boxShadow: `0 12px 24px ${alpha(evenement.color, 0.08)}`,
                            '& .card-overlay': {
                              opacity: 1
                            }
                          }
                        }}
                        onMouseEnter={() => setHoveredCard(evenement.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                      >
                        <CardActionArea 
                          onClick={() => handleNavigation(evenement.lien)}
                          sx={{ height: '100%', cursor: 'pointer' }}
                        >
                          {/* Image avec overlay */}
                          <Box sx={{ position: 'relative', height: 240 }}>
                            <OptimizedImage 
                              src={evenement.image}
                              alt={evenement.title}
                              height={240}
                              objectFit="contain"
                              priority={index === 0}
                            />
                            
                            {/* Overlay au hover */}
                            <Box 
                              className="card-overlay"
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                bgcolor: alpha('#000', 0.6),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: 0,
                                transition: 'opacity 0.3s ease'
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{ 
                                  bgcolor: 'white', 
                                  color: evenement.color,
                                  '&:hover': { bgcolor: '#f5f5f5' }
                                }}
                              >
                                Voir les détails
                              </Button>
                            </Box>
                            
                            {/* Badge */}
                            <Chip
                              label={evenement.badge}
                              size="small"
                              sx={{
                                position: 'absolute',
                                top: 16,
                                left: 16,
                                bgcolor: evenement.color,
                                color: 'white',
                                fontWeight: 600,
                                fontSize: '0.7rem',
                              }}
                            />
                            
                            {/* Stats */}
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                bgcolor: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                p: 1.2,
                                display: 'flex',
                                justifyContent: 'space-around',
                                fontSize: '0.75rem'
                              }}
                            >
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="caption" sx={{ opacity: 0.8 }}>Participants</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{evenement.stats.participants}</Typography>
                              </Box>
                              <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="caption" sx={{ opacity: 0.8 }}>Durée</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{evenement.stats.duration}</Typography>
                              </Box>
                            </Box>
                          </Box>
                          
                          <CardContent sx={{ p: 2.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.5 }}>
                              <Avatar 
                                sx={{ 
                                  bgcolor: alpha(evenement.color, 0.08), 
                                  color: evenement.color,
                                  width: 48,
                                  height: 48,
                                  mr: 2,
                                }}
                              >
                                {evenement.icon}
                              </Avatar>
                              <Box>
                                <Typography 
                                  variant="h6" 
                                  component="h2" 
                                  sx={{ 
                                    fontWeight: 700,
                                    mb: 0.5,
                                    lineHeight: 1.2,
                                    fontSize: '1.05rem'
                                  }}
                                >
                                  {evenement.title}
                                </Typography>
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    color: evenement.color,
                                    fontWeight: 600,
                                    display: 'block'
                                  }}
                                >
                                  {evenement.subtitle}
                                </Typography>
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    mt: 0.5
                                  }}
                                >
                                  <CalendarIcon sx={{ fontSize: 12, mr: 0.5 }} />
                                  {evenement.date}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography 
                              variant="body2" 
                              color="text.secondary" 
                              sx={{ 
                                mb: 2.5,
                                lineHeight: 1.6,
                                fontSize: '0.85rem',
                                height: 54,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical'
                              }}
                            >
                              {evenement.description}
                            </Typography>
                            
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: evenement.color }}>
                                <Typography variant="caption" sx={{ fontWeight: 600, mr: 1 }}>
                                  Consulter
                                </Typography>
                                <ArrowForwardIcon sx={{ fontSize: 16, transition: 'transform 0.3s', 
                                  transform: hoveredCard === evenement.id ? 'translateX(4px)' : 'none' 
                                }} />
                              </Box>
                              <IconButton 
                                size="small" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShare(evenement.title, evenement.lien);
                                }}
                                sx={{ color: 'text.secondary' }}
                              >
                                <ShareIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </motion.div>
                  </Grow>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Section Programme Complet */}
          <Zoom in timeout={800}>
            <Paper 
              sx={{ 
                p: { xs: 3, md: 4 }, 
                mb: 8, 
                bgcolor: 'white',
                border: `1px solid ${alpha(neutralGray, 0.12)}`,
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 2,
                boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
                background: `linear-gradient(135deg, ${white} 0%, ${alpha(neutralGray, 0.02)} 100%)`
              }}
            >
              <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={8}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                      <Avatar 
                        sx={{ 
                          bgcolor: alpha(neutralGray, 0.08), 
                          color: neutralGray,
                          width: 56,
                          height: 56,
                          mr: 2.5,
                        }}
                      >
                        <CalendarIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 400, color: neutralGray, mb: 0.6 }}>
                          Programme Complet MSB 2025
                        </Typography>
                        <Typography variant="h6" sx={{ color: secondaryColor, fontWeight: 400 }}>
                          Du 20 Octobre au 20 Novembre 2025
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Typography variant="body1" paragraph sx={{ mb: 2.5, lineHeight: 1.7, fontSize: '1rem' }}>
                      Découvrez l'ensemble des activités planifiées pour cette 14ème édition, incluant les formations, 
                      ateliers, célébrations et productions statistiques. Chaque activité contribue à renforcer 
                      le Système Statistique National et à promouvoir l'innovation.
                    </Typography>
                    
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ flexWrap: 'wrap' }}>
                      <Button 
                        onClick={() => handleNavigation('/moisStatistique2025')}
                        variant="contained"
                        startIcon={<NewspaperIcon />}
                        sx={{ 
                          bgcolor: neutralGray, 
                          '&:hover': { bgcolor: '#616161' },
                          px: 3,
                          py: 1.2,
                          fontWeight: 600
                        }}
                      >
                        Programme détaillé
                      </Button>
                      <Button 
                        onClick={() => handleNavigation('/lancementMoisStatistique2025')}
                        variant="outlined"
                        startIcon={<LaunchIcon />}
                        sx={{ 
                          borderColor: alpha(primaryColor, 0.3), 
                          color: primaryColor,
                          px: 3,
                          py: 1.2,
                          fontWeight: 600
                        }}
                      >
                        Lancement
                      </Button>
                      <Button 
                        onClick={() => handleNavigation('/formation-inclusion')}
                        variant="outlined"
                        startIcon={<LanguageIcon />}
                        sx={{ 
                          borderColor: alpha(secondaryColor, 0.3), 
                          color: secondaryColor,
                          px: 3,
                          py: 1.2,
                          fontWeight: 600
                        }}
                      >
                        Formations
                      </Button>
                    </Stack>
                  </Grid>
                  
                  <Grid item xs={12} md={4}>
                    <Box sx={{ 
                      bgcolor: alpha(neutralGray, 0.03), 
                      p: 2.5, 
                      borderRadius: 1.5,
                      border: `1px solid ${alpha(neutralGray, 0.1)}`
                    }}>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: neutralGray, mb: 2 }}>
                        En chiffres
                      </Typography>
                      <Stack spacing={2}>
                        <Box>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>Durée</Typography>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>1 mois</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>Activités</Typography>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>20+ événements</Typography>
                        </Box>
                        <Box>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>Partenaires</Typography>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>15+ institutions</Typography>
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Zoom>

          {/* Section Galerie Photos */}
          <Box sx={{ mb: 8 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              mb: 4,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: 0,
                width: '100px',
                height: '2px',
                bgcolor: accentColor,
                borderRadius: 2
              }
            }}>
              <Typography variant="h4" sx={{ color: neutralGray, fontWeight: 700 }}>
                Galerie Photos
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Moments forts des événements
              </Typography>
            </Box>
            
            <Grid container spacing={2}>
              {galerieImages.map((photo, index) => (
                <Grid item xs={12} sm={6} md={3} key={photo.id}>
                  <Grow in timeout={200 + (index * 100)}>
                    <Card 
                      sx={{ 
                        height: '100%',
                        transition: 'all 0.3s ease',
                        overflow: 'hidden',
                        borderRadius: 1.5,
                        boxShadow: theme.shadows[1],
                        '&:hover': {
                          boxShadow: theme.shadows[3],
                          '& .photo-overlay': {
                            opacity: 1
                          },
                          '& .photo-title': {
                            transform: 'translateY(0)'
                          }
                        }
                      }}
                    >
                      <CardActionArea>
                        <Box sx={{ position: 'relative', height: 220 }}>
                          <OptimizedImage 
                            src={photo.image}
                            alt={photo.title}
                            height={220}
                            objectFit="contain"
                          />
                          <Box 
                            className="photo-overlay"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              bgcolor: 'rgba(0,0,0,0.6)',
                              opacity: 0,
                              transition: 'opacity 0.3s ease',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'flex-end',
                              p: 2
                            }}
                          >
                            <Typography 
                              className="photo-title"
                              variant="body1" 
                              sx={{ 
                                color: 'white', 
                                fontWeight: 600,
                                mb: 1,
                                transform: 'translateY(20px)',
                                transition: 'transform 0.3s ease',
                                fontSize: '0.95rem'
                              }}
                            >
                              {photo.title}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.75rem' }}>
                              {photo.event}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', mt: 0.5, fontSize: '0.7rem' }}>
                              {photo.date}
                            </Typography>
                          </Box>
                        </Box>
                      </CardActionArea>
                    </Card>
                  </Grow>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>

        {/* Bouton retour en haut */}
        {showScrollTop && (
          <Fab
            color="primary"
            aria-label="scroll back to top"
            onClick={scrollToTop}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1000,
              bgcolor: alpha(neutralGray, 0.9),
              color: 'white',
              '&:hover': { bgcolor: neutralGray }
            }}
          >
            <TrendingIcon />
          </Fab>
        )}
      </Box>

      <Footer />
    </Box>
  );
}

export default ActualitesEtEvenements;